export enum ErrorCodes {
  E1000 = "E1000", // Cognito Exception
  E1001 = "E1001", // Access Denied
  E1002 = "E1002", // Invalid Usage
  E1003 = "E1003", // Aggregator Exception
  E1004 = "E1004", // User already exists for the provided Email and/or Phone Number
  E1005 = "E1005", // Resource Not Found
  E1006 = "E1006", // User Not Confirmed Exception: User Email not verified
  E1008 = "E1008", // Something went wrong, please contact support
  E1009 = "E1009", // Method Argument not valid
  E1010 = "E1010", // Binding Exception
  E1011 = "E1011", // Type Mismatch
  E1012 = "E1012", // Bad Request
  E1013 = "E1013", // Constraint Violation
  E1014 = "E1014", // Handler Not Found
  E1015 = "E1015", // Method Not Supported
  E1016 = "E1016", // Media Type Not Supported
  E1017 = "E1017", // Data Integrity Violation
  E1018 = "E1018", // Bad HTTP Request
}
